/* js/toggle.js */

jQuery( document ).ready(function( $ ) {

    $('.js-toggleTrigger').click(function () {
            $(this).closest('.js-toggleGroup').toggleClass('js-toggleGroup-open').find('.js-toggleTarget').slideToggle();

       /* var txt = $(".js-toggleTarget").is(':visible') ? 'Less' : 'More';
        $(this).text(txt);*/
    });

});